import type { CourseId } from "./types";

export const homepageMobileSections = ["hero", "exam-goal", "product-demo", "course-comparison", "trust-proof", "faq-action"] as const;
export const primaryExamCourseIds: CourseId[] = ["mblex-prep", "texas-prep", "texas-cosmetology-prep", "texas-esthetician-prep", "texas-barber-prep", "new-york-prep", "hawaii-prep"];
export const careerTrainingCourseIds: CourseId[] = ["massage-ce-12", "cosmetology-ce-4", "professional-dog-grooming"];
export const otherServiceIds = ["license-support"] as const;

export function firstThreeMonthsTotalCents(schedule: number[]) {
  return schedule.length === 3 ? schedule[0] + schedule[1] * 2 : undefined;
}
